export const assessmentInternalErrorMessages = {
  err_attachment_size_limit_exceeded:
    'You can upload files up to 10 MB in size',
  err_attachment_count_limit_exceeded:
    'You can upload a maximum of 10 files at a time',
  err_attachment_type_invalid:
    'This file type isn’t supported. Try compressing the file and uploading it as a zip file',
  err_reviewer_already_responded:
    'This scorecard has been submitted by the reviewer already',
  err_questions_not_editable_once_submitted:
    'Unable to edit this scorecard because a reviewer has already filled it out',
  err_assessment_not_found:
    'Unable to start the assessment as it has not been sent yet',
  err_candidate_email_not_found:
    'Unable to send the assessment as the candidate email is not found',
};
